import { useState, useEffect } from 'react';
import { publicScheduleModelData, scheduleModelData } from '../services/ModelService';

export default function useAllSchedules() {
    const [allSchedules, setAllSchedules] = useState(null);
    const [allPublicSchedules, setAllPublicSchedules] = useState(null);
    const [schedules, setSchedules] = useState(null);

    useEffect(() => {
        const loadSchedules = async () => {
            try {
                const schedules = await scheduleModelData.getAll();
                setAllSchedules(schedules);
                const publicSchedules = await publicScheduleModelData.getAll();
                setAllPublicSchedules(publicSchedules);
                setSchedules({...schedules, ...publicSchedules});
            } catch (error) {
                console.error('Error loading schedules:', error);
            }
        };

        loadSchedules();
    }, []);

    return { allSchedules, allPublicSchedules, schedules };
}
